import http from './httpService';

export function fetchUserApi() {
  return http.get(`/account`);
}

// export function getAllComments() {
//   return http.get(`/comments`);
// }
// comments?riskId.equals=${id}&sort=createdAt,desc

export function getAllAudit(id,page) {
  return http.get(`/risk-audits?riskId.equals=${id}&page=${page}&sort=insertedAt,desc&sort=id,desc`);
}

// export function getAllAudit() {
//   return http.get(`/risk-audit?riskId.equals=1`);
// }